import { MatchPhone } from "refsix-js-models";

/**
 * Minimum minutes played for a match to be considered a "real" completed match
 * worth surfacing the rating prompt for (excludes abandoned / very short matches).
 */
export const MIN_MINUTES_PLAYED_FOR_GOOD_QUALITY = 25;

/**
 * Returns true when a finished match has good-quality GPS *and* heart-rate
 * tracking data (i.e. proper 1Hz watch data for the whole match).
 *
 * Reuses the stats flags already computed during processing:
 *  - gpsProcessed / heartRateProcessed: the data passed validation
 *  - gpsAvailable[0] / heartRateAvailable[0]: data is available for the whole match
 *
 * Used to decide whether the match result is a "moment of value" worthy of
 * prompting the user for an app rating & review.
 */
export function hasGoodQualityFitnessData(match: MatchPhone): boolean {
    if (!match || !match.matchFinished) {
        return false;
    }

    const stats = match.stats;
    if (!stats) {
        return false;
    }

    if (stats.minutesPlayed < MIN_MINUTES_PLAYED_FOR_GOOD_QUALITY) {
        return false;
    }

    const hasGoodGps =
        match.hasTracking === true &&
        stats.gpsProcessed === 1 &&
        stats.gpsAvailable?.[0] === 1;

    const hasGoodHeartRate =
        match.hasHeartRate === true &&
        stats.heartRateProcessed === 1 &&
        stats.heartRateAvailable?.[0] === 1;

    return hasGoodGps && hasGoodHeartRate;
}
